$(document).ready(function(){
  

//     if($("#min-val").val() == ''){
//       var min = parseInt($("#min-val").attr('min'));
//     }else{
//       var min = parseInt($("#min-val").val());
//     }
//     if($("#max-val").val() == ''){
//       var max = parseInt($("#max-val").attr('max'));
//     }else{
//       var max = parseInt($("#max-val").val());
//     }
//     var def_min = parseInt($('#min-val').attr('min'));
//     var def_max = parseInt($('#max-val').attr('max'));
    
//    console.log(def_min,def_max,min,max);

//   function RangeSlider(min,max,def_min,def_max){
//     var slider = document.getElementById('slider');
//     noUiSlider.create(slider, {
//         start: [min, max],
//         connect: true,
//         range: {
//             'min': def_min,
//             'max': def_max
//         }
//     });
    
//   var snapValues = [
//       document.getElementById('min-val'),
//       document.getElementById('max-val')
//   ];
//     slider.noUiSlider.on('update', function (values,handle) {
//         snapValues[handle].value = values[handle]; 
//     });     
//   }
//  RangeSlider(min,max,def_min,def_max);

 
//    $('body').on('change','input[type="number"]',function(){
//     var min_value = $("#min-val").val();
//     var max_value = $("#max-val").val();
//     slider.noUiSlider.set([min_value, max_value]);
//   });


    $('body').on('click','.slideout__button',function(e){
        e.preventDefault();
        $('.collection-sidebar').addClass('active');
        $('body').addClass('overflow-hidden'); 
    });
  
    $('body').on('click','.filter-group-summary',function(){
      $(this).toggleClass('active');
      $(this).parents('.filter-group').find('.filter-group-display').toggleClass('active');
      $(this).parents('.filter-group').find('.filter-group-display').slideToggle();
    });


    $('body').on('click','.filter-close,.overlay-filter',function(){
       $('.collection-sidebar').removeClass('active');
       $('body').removeClass('overflow-hidden'); 
    });
 
    $('body').on('click','.active-fillter-remove',function(e){
      e.preventDefault();
      var path = $(this).attr('href');
      var paramsup = {
      type: 'GET',
      url: path,
      success: function(data) { 
        window.history && window.history.pushState && window.history.pushState("", "", path);
        var content = $(data).find('.fillter_wrpper').html();
        $('.fillter_wrpper').html(content);
        var headerContent = $(data).find('.collection-header-main').html();
        $('.collection-header-main').html(headerContent);
        var grid = $(data).find('.results--container').html();
        var filters = $(data).find('[data-filters-options]').html();
        $('.results--container').html(grid);
        $('[data-filters-options]').html(filters);

      // if($(data).find("#fillter_min").val() == ''){
      //   var min = parseInt($("#fillter_min").attr('min'));
      // }else{
      //   var min = parseInt($("#fillter_min").val());
      // }
      // if($(data).find("#fillter_max").val() == ''){
      //   var max = parseInt($("#fillter_max").attr('max'));
      // }else{
      //   var max = parseInt($("#fillter_max").val());
      // }
      // var def_min = parseInt($("#fillter_min").attr('min'));
      // var def_max = parseInt($("#fillter_max").attr('max'));

      $('.results--container img[data-rimg="lazy"]').each(function () {
          $(this).attr('srcset', $(this).attr('src'));
          $(this).attr('data-rimg', 'loaded');
      });

       reinitializeProductCards();

      },
      error: function() {
      }
    };
    $.ajax(paramsup);
    return false; 
  });


    $('body').on('click', '.filter-apply-btn', function (e) {
      e.preventDefault();

      var form_data = $(this).closest('.fillter_wrpper').find('form').serialize();
      var path = window.location.pathname;

      $.ajax({
        type: 'GET',
        url: path + '?' + form_data,
        success: function (data) {

          $('body').removeClass('overflow-hidden');

          if (window.history && window.history.pushState) {
            window.history.pushState("", "", path + '?' + form_data);
          }

          var content = $(data).find('.fillter_wrpper').html();
          $('.fillter_wrpper').html(content);

          var headerContent = $(data).find('.collection-header-main').html();
          $('.collection-header-main').html(headerContent);

          var grid = $(data).find('.results--container').html();
          $('.results--container').html(grid);

          var filters = $(data).find('[data-filters-options]').html();
          $('[data-filters-options]').html(filters);

          $('.results--container img[data-rimg="lazy"]').each(function () {
            $(this).attr('srcset', $(this).attr('src'));
            $(this).attr('data-rimg', 'loaded');
          });

          reinitializeProductCards();
        },
        error: function () {
          console.log('Filter request failed');
        }
      });
    });


// Open / Close Dropdown
$('body').on('click', '.select_dropdown_toggle', function(e) {
    e.stopPropagation();

    $(this).toggleClass('active');
    $('.select_dropdown_list').not($(this).siblings('.select_dropdown_list')).removeClass('active');
    $(this).siblings('.select_dropdown_list').toggleClass('active');
});

// Close on outside click
$(document).on('click', function() {
    $('.select_dropdown_toggle').removeClass('active');
    $('.select_dropdown_list').removeClass('active');
});

// Select Option
$('body').on('click', '.select_dropdown_list li', function() {

    var value = $(this).data('value');
    var text = $(this).text();

    // Active class
    $(this).addClass('active').siblings().removeClass('active');

    // Update button text
    $(this)
      .closest('.select_dropdown')
      .find('.select_dropdown_toggle .select_value')
      .text(text);

    // Update hidden field
    $('#custom-sort-by').val(value);

    // Close dropdown
    $(this)
      .closest('.select_dropdown_list')
      .removeClass('active');

    // Ajax
    var form_data = $('#filterForm').serialize();
    var path = window.location.pathname;

    $.ajax({
        type: 'GET',
        url: path + '?' + form_data,
        success: function(data) {

            window.history &&
            window.history.pushState &&
            window.history.pushState("", "", path + '?' + form_data);

            var content = $(data).find('.fillter_wrpper').html();
            $('.fillter_wrpper').html(content);

            var grid = $(data).find('.results--container').html();
            $('.results--container').html(grid);

            var filters = $(data).find('[data-filters-options]').html();
            $('[data-filters-options]').html(filters);

            $('.results--container img[data-rimg="lazy"]').each(function () {
                $(this).attr('srcset', $(this).attr('src'));
                $(this).attr('data-rimg', 'loaded');
            });

            reinitializeProductCards();
        },
        error: function() {
            console.log('Sort request failed');
        }
     });
    });

    function reinitializeProductCards() {

      /* Hover visible class */
      $('.productgrid--item').off('mouseenter.productHover');
      $('.productgrid--item').off('mouseleave.productHover');

      $('.productgrid--item').on('mouseenter.productHover', function () {
        $(this).addClass('visible');
      });

      $('.productgrid--item').on('mouseleave.productHover', function () {
        $(this).removeClass('visible');
      });
      $(document).trigger('theme:section:load');
    }

    $('body').on('click', '.filter-toggle-btn', function () {
      $('html, body').animate({
          scrollTop: 0
      }, 600);
    });

    $(window).on('scroll', function () {
      if ($(this).scrollTop() > 300) {
          $('.filter-toggle-btn').removeClass('d_none');
      } else {
          $('.filter-toggle-btn').addClass('d_none');
      }
    });

});
     
